module.exports = __webpack_public_path__ + "img/MotoBtn.5cac8ce2.svg";